
export function setSecureStateCookie(name: string, state: string) {
  const expires = new Date(Date.now() + 10 * 60 * 1000).toUTCString()
  console.info(`Set state cookie for ${name}`)
  document.cookie = `${name}=${encodeURIComponent(state)}; Path=/; SameSite=None; Secure; Max-Age=600; Domain=.matter.jetbrains.ai; Expires=${expires}`
}

export function dropSecureStateCookie(name: string) {
  console.info(`Dropped state cookie for ${name}`)
  document.cookie = `${name}=; Path=/; SameSite=None; Secure; Domain=.matter.jetbrains.ai; expires=Thu, 01 Jan 1970 00:00:00 UTC;`
}


export const SlackSecureCookie = "slack_oauth_state"
export const FigmaSecureCookie = "figma_oauth_state"